import { useQuery } from '@tanstack/react-query'
import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { getAkairosShipments } from '~/lib/handle-api'

import { DeliveryIcon } from '~/components/UI/Icons'

import { useGlobalData } from '~/providers/GlobalDataProvider'
import { useStyle } from '~/providers/StyleProvider'

import useLocale from '~/hooks/useLocale'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface DeliveryInformationsProps {
  className?: string
  productSku?: string
}

export default function DeliveryInformations({
  className,
  productSku,
}: DeliveryInformationsProps) {
  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Text12Secondary,
    color: GlobalThemeColors.Gray1ToBlack,
  })

  const { global } = useGlobalData()
  const locale = useLocale()

  const { data: deliveryInformationsText, isLoading } = useQuery(
    ['delivery-informations'],
    async () => {
      const date = new Date()

      const shipments = await getAkairosShipments({
        queryParams: {
          timezoneOffset: String(date.getTimezoneOffset()),
          skuCodes: productSku,
        },
        payload: {
          dictionary: global?.dictionary,
          locale,
        },
      })

      return shipments?.data
    },
  )

  return (
    <div className={cx(css.DeliveryInformations, className, { isLoading })}>
      <DeliveryIcon className={cx(css.icon)} />
      {isLoading && (
        <div className={cx(css.text, textStyle)}>
          <span>&nbsp;</span>
          <span>&nbsp;</span>
        </div>
      )}
      {!isLoading && deliveryInformationsText && (
        <div className={cx(css.text, textStyle)}>
          {deliveryInformationsText}
        </div>
      )}
    </div>
  )
}
